// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1ProjectSchema } from './v1/projectSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const showProjectPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Project ID"),
});

export const showProjectHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Project details
 */
export const showProject200Schema = z.lazy(() => v1ProjectSchema);

/**
 * @description Unauthorized
 */
export const showProject401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Project not found
 */
export const showProject404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const showProjectQueryResponseSchema = z.lazy(() => showProject200Schema);
